<template>
  <div class="page page__has-bar">
    <div class="page__bd" v-if="hasMember">
      <div class="weui-cells member-list">
        <router-link
          class="weui-cell weui-cell_active"
          v-for="item in member.employees"
          :key="item.id"
          :to="'/document/virtual_employee/'+item.id"
          href="javascript:;"
        >
          <div class="weui-cell__hd">
            <div class="square-icon">
              <span class="iconfont icon-user"></span>
            </div>
          </div>
          <div class="weui-cell__bd weui-cell_primary">
            <p>{{item.ve_name}}</p>
          </div>
          <span class="weui-cell__ft"></span>
        </router-link>
        <router-link
          class="weui-cell weui-cell_active"
          v-for="item in member.children"
          :key="item.id"
          :to="'/sys/virtual_org/'+item.id"
          href="javascript:;"
        >
          <div class="weui-cell__hd">
            <div class="square-icon org-icon">
              <span class="iconfont icon-folder"></span>
            </div>
          </div>
          <div class="weui-cell__bd weui-cell_primary">
            <p>{{item.vo_name}}</p>
          </div>
          <span class="weui-cell__ft"></span>
        </router-link>
      </div>
      <div class="weui-footer">
        <p class="weui-footer__text">共{{member.total}}人</p>
      </div>
    </div>

    <div v-else class="weui-msg">
      <div class="weui-msg__icon-area">
        <i class="weui-icon-info weui-icon_msg"></i>
      </div>
      <div class="weui-msg__tips-area">
        <p class="weui-msg__tips">无子组织或此组织无成员</p>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <router-link
        v-if="member.virtualOrg && member.virtualOrg.id"
        :to="'/document/virtual_org_edit?id='+member.virtualOrg.id"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="add"
      >新增</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        v-if="member.virtualOrg && !hasMember"
        @click="remove"
      >删除</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name) {
        this.loadData();
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.loadData();
    });
  },
  data() {
    return {
      baseUrl: "/api/document/virtual_org",
      member: {
        virtualOrg: {},
        children: [],
        employees: [],
        total: 0,
      },
    };
  },
  computed: {
    hasMember() {
      var member = this.member;
      return member.total || (member.children && member.children.length);
    },
  },
  methods: {
    loadData() {
      var me = this;
      me.$loading({
        url: me.baseUrl + "/member",
        params: {
          id: me.id,
        },
      }).then(function (res) {
        if (res.success) {
          me.member = res.data;
          if(me.member.virtualOrg && me.member.virtualOrg.vo_name) {
            document.title = me.member.virtualOrg.vo_name;
          }
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    add() {
      var me = this
      if(me.member.virtualOrg) {
        var virtualOrg = me.member.virtualOrg;
        me.$weui.actionSheet([
          {
            label: "子组织",
            onClick: function () {
              me.$router.push({
                name: "DocumentVirtualOrgEdit",
                params: {
                  initData: {
                    vo_subof: virtualOrg.id,
                  },
                },
              });
            },
          },
          {
            label: "人员",
            onClick: function () {
              me.$router.push({
                name: "DocumentVirtualEmployeeEdit",
                params: {
                  initData: {
                    ve_orgid: virtualOrg.id,
                    ve_orgname: virtualOrg.vo_name,
                  },
                },
              });
            },
          },
        ]);
      }
      else {
        me.$router.push({
          name: "DocumentVirtualOrgEdit",
          params: {
            initData: {
              vo_subof: 0,
            },
          },
        });
      } 
    },
    remove() {
      var me = this,
        virtualOrg = me.member.virtualOrg,
        id = virtualOrg.id;
      me.$weui.confirm(`确定删除 ${virtualOrg.vo_name}？`, function () {
        me.$loading({
          url: me.baseUrl + "/delete/" + id,
          method: "POST",
        })
          .then(function (res) {
            if (res.success) {
              me.$weui.toast("删除成功", 2000);
              me.$router.back();
            } else {
              me.$weui.topTips("删除失败: " + res.message, 3000);
            }
          })
          .catch(function () {
            me.$weui.topTips("删除失败", 3000);
          });
      });
    },
  },
}
</script>

<style scoped>
.member-list {
  margin: 0 0 8px 0;
}
.member-list:before {
  display: none;
}
.member-list .weui-cell {
  padding: 7px 14px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: inherit;
}
.member-list .weui-cell:before {
  left: 68px;
}
.member-list .role-list {
  margin-top: 0;
}
.member-list .role-list > span {
  color: var(--weui-FG-2);
  margin-right: 8px;
}
.member-list .weui-cell__hd {
  margin-right: 10px;
}
.org-icon .iconfont{
  color: var(--weui-BTN-DEFAULT-COLOR)
}
</style>